import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store/store'
import axios from 'axios'
import router from './router'
import { marked } from 'marked'
import { markedHighlight } from 'marked-highlight'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'

 marked.use(markedHighlight({
        renderer: new marked.Renderer(),
        gfm: true,
        headerIds: false,
        tables: true,
        breaks: true,
        langPrefix: 'hljs language-',
        highlight:function(code, lang){
          const validLanguage = lang && hljs.getLanguage(lang) ? lang : 'plaintext';
          return hljs.highlight(code, { language: validLanguage }).value;
        },
        pedantic: false,
        sanitize: false,
        smartLists: true,
        smartypants: false
      }));

Vue.prototype.$marked = marked;

//kwak add
const customRenderer = new marked.Renderer();
customRenderer.link = function(token) {
  const href = token.href || '#';
  const text = token.text || '';
  return `<a href="javascript:void(0);" onclick="openLink('${href}')">${text}</a>`;
};
Vue.prototype.$custommarked = (text) => marked(text, { renderer: customRenderer });
//

axios.interceptors.response.use(
  (response) => response,
  (error)=>{
    console.log("interceptors")
    if(error.response && error.response.status === 401){
      store.commit("logout");
      if(router.currentRoute.path !=="/login"){
        router.push("/login");
      }
    }
    return Promise.reject(error);
  }
)

Vue.config.productionTip = false

console.log('Current Environment: ', process.env.NODE_ENV);

const apiUrl = process.env.NODE_ENV === 'production'
  ? 'https://vul-api.wikisecurity.net:8080'
  : 'https://192.168.20.107:8081';

Vue.prototype.$apiUrl= apiUrl;
export default apiUrl

Vue.prototype.$axios= axios;

axios.defaults.withCredentials = true;
new Vue({
  vuetify,
  store,
  axios,
  router,
  render: h => h(App)
}).$mount('#app')
